import { render, staticRenderFns } from "./Showcase.vue?vue&type=template&id=2bcc7cfc&scoped=true"
import script from "./Showcase.vue?vue&type=script&lang=js"
export * from "./Showcase.vue?vue&type=script&lang=js"
import style0 from "./Showcase.vue?vue&type=style&index=0&id=2bcc7cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc7cfc",
  null
  
)

export default component.exports